import Vue from 'vue';
import { mapGetters } from 'vuex';

export default Vue.component('video-player-loader', {
  template: require('./template.html'),
  name: 'video-player-loader',
  computed: {
    ...mapGetters(['activeDroplet']),
  },
});



// WEBPACK FOOTER //
// ./src/global-view/editor/droplets/video-player/components/_preview/loader/index.js